import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, getInputFormattedDateFromString } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import CreditListItem from '../components/creditListItem.js';
import Progress from '../components/progress.js';
import { Paginator } from '../components/paginator.js';
import SearchClient from '../components/searchClient.js';
import Sort from '../components/sort.js';
import SearchInvoice from '../components/searchInvoice.js';
let searchData = {};

function Credits() {
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('credit.updation_date');
  const [sortOrder, setSortOrder] = useState(false);
  const [dateSearch, setDateSearch] = useState('none');
  const [credits, setCredits] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [description, setDescription] = useState(null);
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState('INR');
  const [validTill, setValidTill] = useState(getInputFormattedDateFromString(Date.now()));
  const [createdDate, setCreatedDate] = useState(getInputFormattedDateFromString(Date.now()));
  const [remark, setRemark] = useState('');
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  const [total, setTotal] = useState(0);
  const [filterTotal, setFilterTotal] = useState(0);
  const [client, setClient] = useState(null);
  const [invoice, setInvoice] = useState(null);
  

  const handleSubmit = (event) =>{
    event.preventDefault();
    if(amount && parseInt(amount) > 0 && description && validTill && client && parseInt(amount) <= parseInt(invoice.paid)){
      const formData = new FormData;
      formData.append('description', description);
      formData.append('remark', remark);
      formData.append('valid_till', validTill);
      formData.append('createdDate', createdDate);
      formData.append('task', "create");
      formData.append('client', client.client_id);
      formData.append('amount', amount);
      formData.append('currency', currency);
      formData.append('notifySms', notifySms);
      formData.append('notifyMail', notifyMail);
      formData.append('invoice', invoice.invoice_id);
      formData.append('token', localStorage.getItem("token"));
      setLoading(true);
      axios.post(global.config.api_server+'credit',formData).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Credit Note Created');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
          setLoading(false);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Fields must have valid values');
      setLoading(false);
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  const fetchCredits = (pSortBy, pSortOrder, pPage, pSearch, pSearchType) => {
    let dateQ = "";
    if(pSearchType === 'range'){
      dateQ = "credit.updation_date>"+searchData.dateSearchFrom+",credit.updation_date<"+searchData.dateSearchTo;
    }else if (pSearchType === 'monthYear'){
      if(searchData.dateSearchMonth > 0 && searchData.dateSearchYear > 0){
        dateQ = "MONTH(credit.updation_date);"+searchData.dateSearchMonth+",YEAR(credit.updation_date);"+searchData.dateSearchYear;
      }else if(searchData.dateSearchMonth > 0){
        dateQ = "MONTH(credit.updation_date);"+searchData.dateSearchMonth;
      }else if(searchData.dateSearchYear > 0){
        dateQ = "YEAR(credit.updation_date);"+searchData.dateSearchYear;
      }
    }
    let q = "";
    if(pSearch & dateQ != ''){
      q = "q="+pSearch+","+dateQ+"&";
    }else if (pSearch){
      q = "q="+pSearch+"&";
    }else if (dateQ != ''){
      q = "q="+dateQ+"&";
    }
    let order = 'desc';
    if(pSortOrder){
      order = 'asc';
    }
    let uri = global.config.api_server+'credits?limit='+global.config.items_per_page+'&page='+pPage+'&orderBy='+pSortBy+'&order='+order+'&'+q+'token='+localStorage.getItem("token");
    axios.get(uri)
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        setCredits(res.data.credits);
        setTotal(res.data.total);
        setFilterTotal(res.data.filterTotal);
        setLoading(false);
      }
    }).catch(err => {
      alertService.error(err);
    });
  }

  const checkHandleSearch = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  }

  const handleSearch = (event) => {
    fetchCredits(sortBy, sortOrder, 0, search, dateSearch);
  }

  const handleSearchInput = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    searchData[name] = value;
  }

  const updateSortParam = (e, field) => {
    let newSearchOrder = true;
    if(field === sortBy){
      newSearchOrder = !sortOrder;
    }else{
      setSortBy(field);
    }
    setSortOrder(newSearchOrder);
    fetchCredits(field, newSearchOrder, 0, search, dateSearch);
  }
  
  const resetSearch = (event) => {
    setSearch('');
    setDateSearch("none");
    searchData = {};
    fetchCredits(sortBy, sortOrder, 0, null, 'none');
  }
  
  useEffect(()=>{
    fetchCredits(sortBy, sortOrder, 0, search, dateSearch);
  }, []);
  
  const onPageChange = (index_start) => {
    let lPage = index_start / global.config.items_per_page;
    setPage(lPage);
    fetchCredits(sortBy, sortOrder, lPage, search, dateSearch);
  }

  return(
    <div className="container-fluid">
      {loading === true ? (
        <Progress label='Loading..'/>
      ):
      <div>
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <a href="#" className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#createNewCreditModal">
              <span className="icon text-white-50">
                <i className="fas fa-credit-card"></i>
              </span>
              <span className="text">Create Credit Note</span>
            </a>
            <h6 className={'form-group mr-3 font-weight-bold text-'+theme()}>Credits</h6>
            <div class="search-container">
              <div className="form-group mr-3">
                <input name="search" className="form-control" placeholder="Search" value={search} onKeyDown={(e) => checkHandleSearch(e)} onChange={(e) => setSearch(e.target.value)}/>
              </div>
              <div className={"form-group mr-3"}>
                <select name="dateSearch" className="form-control" value={dateSearch} id="dateSearch" onChange={(e) => setDateSearch(e.target.value)}>
                  <option value="none">Search By Date</option>
                  <option value="range">Range</option>
                  <option value="monthYear">Month-Year</option>
                </select>
              </div>
              {dateSearch === 'range' && 
                <div className="form-group mr-3">
                  <input type="date" name="dateSearchFrom" className="form-control" placeholder="From" onChange={(e)=>handleSearchInput(e)}/>
                </div>
              }
              {dateSearch === 'range' && 
                <div className="form-group mr-3">
                  <input type="date" name="dateSearchTo" className="form-control" placeholder="To" onChange={(e)=>handleSearchInput(e)}/>
                </div>
              }
              {dateSearch === 'monthYear' && 
                <div className="form-group mr-3">
                  <select name="dateSearchMonth" className="form-control" id="dateSearchMonth" onChange={(e)=>handleSearchInput(e)}>
                    {global.config.months.map(d =>
                        <option value={d.value} key={d.value}>{d.name}</option>
                    )}
                  </select>
                </div>
              }
              {dateSearch === 'monthYear' && 
                <div className="form-group mr-3">
                  <select name="dateSearchYear" className="form-control" id="dateSearchYear" onChange={(e)=>handleSearchInput(e)}>
                    <option value="0">None</option>
                    {global.config.years.split(",").map(d =>
                        <option value={d} key={d}>{d}</option>
                    )}
                  </select>
                </div>
              }
              <div className="form-group mr-3">
                <a href="#" className="btn btn-primary btn-icon-split" onClick={handleSearch}>
                  <span className="icon">
                    <i className="fas fa-search"></i>
                  </span>
                </a>
              </div>
              {(search || dateSearch != 'none' ) &&
                <div className="form-group mr-3">
                  <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                    <span className="icon">
                      <i className="fas fa-times"></i>
                    </span>
                  </a>
                </div>
              }
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <div className="row">
                <div className="col-sm-12">
                  <table className="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th onClick={(e) => updateSortParam(e,'credit_id')}>Credit Note Id <Sort field="credit_id" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'client.first_name')}>Client <Sort field="client.first_name" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th>Description</th>
                        <th onClick={(e) => updateSortParam(e,'status')}>Status <Sort field="status" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'amount')}>Amount <Sort field="amount" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'currency')}>Currency <Sort field="currency" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'updation_date')}>Updated On <Sort field="updation_date" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {credits.map(credit=>
                        <CreditListItem key={credit.credit_id} info={credit} type="all"/>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <Paginator
                itemCount={filterTotal}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filterTotal}
                grandTotal={total}
                onClick={onPageChange.bind(this)}
              />
            </div>
          </div>
        </div>
        <div className="modal fade" id="createNewCreditModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="create-popup">Create Credit</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <SearchClient handleSubmit={(e) => setClient(e)}></SearchClient>
                  {client && 
                    <SearchInvoice handleSubmit={(e) => { setInvoice(e); setCurrency(e.currency);}} client={client.client_id}></SearchInvoice>
                  }
                  {invoice &&
                    <div>
                      <div className="form-group">
                        <label>Amount (Less than or equal to: {invoice.paid})*</label>
                        <input type="number" value={amount} maxLength="50" name="amount" className="form-control" id="amount" placeholder="Enter Amount" onChange={(e) => setAmount(e.target.value)}/>
                      </div>
                      <div className="form-group">
                        <label>Currency*</label>
                        <select name="type" className="form-control" id="type" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                          {global.config.currencies.split(",").map(d =>
                              <option value={d} key={d}>{d}</option>
                          )}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Description *</label>
                        <textarea maxLength="400" name="description" className="form-control textarea-lg" id="description" placeholder="Description" onChange={(e) => setDescription(e.target.value)}></textarea>
                      </div>
                      <div className="form-group">
                        <label>Valid Till *</label>
                        <input type="date" value={validTill} maxLength="50" name="validTill" className="form-control" id="validTill" placeholder="Enter Valid Till" onChange={(e) => setValidTill(e.target.value)}/>
                      </div>
                      <div className="form-group">
                        <label>Creation Date</label>
                        <input type="date" value={createdDate} maxLength="50" name="createdDate" className="form-control" id="createdDate" placeholder="Enter Created Date" onChange={(e) => setCreatedDate(e.target.value)}/>
                      </div>
                      <div className="form-group">
                        <label>Additional Note</label>
                        <textarea maxLength="200" value={remark} name="remark" className="form-control textarea-md" id="remark" placeholder="Additional Note" onChange={(e) => setRemark(e.target.value)}></textarea>
                      </div>
                      <div className="form-group">
                        <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
                      </div>
                    </div>
                  }
                  {loading === true ? (
                    <Progress label='Creating..' small={true}/>
                  ):null}
                </div>
                <div className="modal-footer">
                  <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                  <button className={'btn btn-'+theme()} type="button" onClick={handleSubmit}>Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    }
    </div>
  )
}

export default Credits;